import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  createEmailSetting,
  updateEmailSetting,
  getAllEmailSettings,
  deleteEmailSetting, 
  createMsgClubSmsSetting,
  createTwilioSmsSetting,      // <--- ADD THIS
  updateTwilioSmsSetting,      // <--- ADD THIS
  getAllTwilioSmsSettings, 
  deleteTwilioSmsSetting,      // <--- ADD THIS
  deleteMsgClubSmsSetting,    // <--- ADD THIS
  updateMsgClubSmsSetting,
  getAllMsgClubSmsSettings,
  createNotificationSetting,
  getAllNotificationSettings,
  updateNotificationSetting,
  deleteNotificationSetting,
  resetNotificationState,
} from "../../actions/notificationActions"; // ASSUMES this file is updated for graceful error handling
import { Link } from "react-router-dom";
// MessageModal Component
import MessageModal from "../Pages/MessageModel";

// ==================== UTILITY FUNCTIONS ====================

// Utility to check if a value represents 'true' across different types (string, boolean, number)
const isTrueValue = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string")
    return value.toLowerCase() === "true" || value === "1";
  if (typeof value === "number") return value === 1;
  return false;
};

const NotificationSettings = () => {
  const dispatch = useDispatch();

  // Get state from Redux store
  const notificationState = useSelector((state) => state.notification);

  const {
    emailSettings = [],
    emailSettingLoading,
    emailSettingError,
    twilioSmsSettings = [],       // <--- ADD THIS
    twilioSmsSettingLoading,      // <--- ADD THIS
    twilioSmsSettingError, 
    msgClubSmsSettings = [],
    msgClubSmsSettingLoading,
    msgClubSmsSettingError,
    notificationSettings = [],
    notificationSettingLoading,
    notificationSettingError,
  } = notificationState || {};

  // Get hospital ID from localStorage
  const getHospitalId = useCallback(() => {
    const loginData = JSON.parse(localStorage.getItem("loginData") || "{}");
    // Ensure the ID is always a string for consistent comparison
    return String(loginData.hospitalID || "0");
  }, []);

  // Memoized current hospital ID
  const currentHospitalId = useMemo(
    () => String(getHospitalId()),
    [getHospitalId],
  );

  // Main tabs state
  const [activeTab, setActiveTab] = useState("notification");
  const [notificationTypeTab, setNotificationTypeTab] = useState("email");

  // Form states - Using currentHospitalId for initial state
  const [smsServiceSettings, setSmsServiceSettings] = useState({
    field1: "",
    field2: "",
    field3: "",
    hid: currentHospitalId,
  });

  // const [emailServiceSettings, setEmailServiceSettings] = useState({
  //   service: "gmail",
  //   user: "",
  //   pass: "",
  //   is_enabled: "0",
  //   hid: currentHospitalId,
  //   use_own_credentials: 0,
  // });
  const [emailServiceSettings, setEmailServiceSettings] = useState({
  hid: currentHospitalId,
  smtp_host: "",
  smtp_port: "587",
  smtp_user: "",
  smtp_pass: "",
  smtp_secure: 0,
  from_email: "",
  from_name: "",
  reply_to: "",
  is_enabled: 1,
  provider_type: "smtp"
});

  // Separate forms for Email and SMS notifications
  const [emailNotification, setEmailNotification] = useState({
    Event: "",
    Email: "true",
    SMS: "false",
    sms_type: "false",
    App: "false",
    SampleMessage: "false",
    EventKey: "", 
    EmailSubject: "",
    EmailBody: "",
    hospitalID: currentHospitalId,
    dlt_entity_id: "false",
    dlt_template_id: "false",
    sender_id: "false",
      IsEmailEnabled: 1,
  IsSmsEnabled: 0, 
  originalData: null 
  });

  const [smsNotification, setSmsNotification] = useState({
    Event: "",
    Email: "false",
    SMS: "true",
    EventKey: "",
    sms_type: "transactional",
    App: "false",
    SampleMessage: "",
    EmailSubject: "false",
    EmailBody: "false",
    hospitalID: currentHospitalId,
    dlt_entity_id: "",
    dlt_template_id: "",
    sender_id: "",
     IsEmailEnabled: 0,
  IsSmsEnabled: 1,
  originalData: null 
  });

  // Edit states
  const [editingNotification, setEditingNotification] = useState(null);
  const [editingType, setEditingType] = useState(""); // 'email' or 'sms'

  // Filter states for tables
  const [notificationFilter, setNotificationFilter] = useState("");

  // Message Modal states
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalVariant, setModalVariant] = useState("info");
  const [modalConfirmAction, setModalConfirmAction] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
    const [smsProvider, setSmsProvider] = useState("twilio"); // 'twilio' or 'msgclub'
const [twilioSettings, setTwilioSettings] = useState({
    field1: "", field2: "", field3: "", field4: "", field5: "1", hid: currentHospitalId
});
  // Pending actions
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  // ==================== MESSAGE MODAL FUNCTIONS ====================

  const showMessage = useCallback((title, message, variant = "info") => {
    setModalTitle(title);
    setModalMessage(message);
    setModalVariant(variant);
    setModalConfirmAction(null);
    setModalShow(true);
  }, []);

  const showSuccess = useCallback(
    (message) => {
      showMessage("Success", message, "success");
    },
    [showMessage],
  );

  const showError = useCallback(
    (message) => {
      showMessage("Error", message, "danger");
    },
    [showMessage],
  );

  const showWarning = useCallback(
    (message) => {
      showMessage("Warning", message, "warning");
    },
    [showMessage],
  );

  const showInfo = useCallback(
    (message) => {
      showMessage("Info", message, "info");
    },
    [showMessage],
  );

  const showConfirmation = useCallback((title, message, onConfirm) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalVariant("warning");
    setModalConfirmAction(() => onConfirm);
    setModalShow(true);
  }, []);

  const handleModalConfirm = useCallback(async () => {
    if (modalConfirmAction) {
      setModalLoading(true);
      try {
        await modalConfirmAction();
        setModalShow(false);
      } catch (error) {
        showError(error.message);
      } finally {
        setModalLoading(false);
        setModalConfirmAction(null);
      }
    } else {
      setModalShow(false);
    }
  }, [modalConfirmAction, showError]);

  const handleModalClose = useCallback(() => {
    setModalShow(false);
    setModalConfirmAction(null);
    setPendingDeleteId(null);
    setModalLoading(false);
  }, []);

  // ==================== UTILITY FUNCTIONS (continued) ====================

  const log = useCallback((message, data = null, type = "info") => {
    const timestamp = new Date().toISOString();
    const styles = {
      info: "color: blue; font-weight: bold;",
      success: "color: green; font-weight: bold;",
      warning: "color: orange; font-weight: bold;",
      error: "color: red; font-weight: bold;",
      debug: "color: purple; font-weight: bold;",
    };
    // eslint-disable-next-line no-console
    console.log(
      `%c[${timestamp}] ${message}`,
      styles[type],
      data !== null ? data : "",
    );
  }, []);

  // Memoized filtering logic
  const hospitalNotificationSettings = useMemo(() => {
    return (notificationSettings || []).filter(
      (notification) =>
        // Compare string representations to avoid issues if one is number and the other is string
        String(notification.hospitalID) === currentHospitalId,
    );
  }, [notificationSettings, currentHospitalId]);

  const filteredNotificationSettings = useMemo(() => {
    return hospitalNotificationSettings.filter(
      (notification) =>
        notification.Event?.toLowerCase().includes(
          notificationFilter.toLowerCase(),
        ) ||
        notification.SampleMessage?.toLowerCase().includes(
          notificationFilter.toLowerCase(),
        ),
    );
  }, [hospitalNotificationSettings, notificationFilter]);

  // const emailNotifications = useMemo(
  //   () => filteredNotificationSettings.filter((n) => isTrueValue(n.Email)),
  //   [filteredNotificationSettings],
  // );

  // const smsNotifications = useMemo(
  //   () => filteredNotificationSettings.filter((n) => isTrueValue(n.SMS)),
  //   [filteredNotificationSettings],
  // );
// Email Notifications को फिल्टर करें (IsEmailEnabled === 1)
// const emailNotifications = useMemo(
//   () => hospitalNotificationSettings.filter((n) => n.IsEmailEnabled === 1 || n.IsEmailEnabled === "1"),
//   [hospitalNotificationSettings]
// );

// // SMS Notifications को फिल्टर करें (IsSmsEnabled === 1)
// const smsNotifications = useMemo(
//   () => hospitalNotificationSettings.filter((n) => n.IsSmsEnabled === 1 || n.IsSmsEnabled === "1"),
//   [hospitalNotificationSettings]
// );
const emailNotifications = useMemo(
  () => hospitalNotificationSettings, 
  [hospitalNotificationSettings]
);

const smsNotifications = useMemo(
  () => hospitalNotificationSettings,
  [hospitalNotificationSettings]
);
  const hasEmailSettings = useMemo(
    () =>
      emailSettings.some(
        (setting) =>
          String(setting.hid || setting.hospitalID) === currentHospitalId,
      ),
    [emailSettings, currentHospitalId],
  );

  const hasSmsSettings = useMemo(
    () =>
      msgClubSmsSettings.some(
        (setting) =>
          String(setting.hid || setting.hospitalID) === currentHospitalId,
      ),
    [msgClubSmsSettings, currentHospitalId],
  );

  // ==================== EFFECT HOOKS ====================

  // Load data on component mount
  useEffect(() => {
    loadAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array means run once on mount

  // Load existing settings when data changes - Filter by current hospital ID
  useEffect(() => {
    log("🔄 Processing email and SMS settings", {
      emailSettings: emailSettings?.length,
      msgClubSmsSettings: msgClubSmsSettings?.length,
    });

    if (emailSettings && emailSettings.length > 0) {
      // Filter email settings for current hospital
      const hospitalEmailSettings = emailSettings.filter(
        (setting) =>
          String(setting.hid || setting.hospitalID) === currentHospitalId,
      );
      if (hospitalEmailSettings.length > 0) {
        setEmailServiceSettings(hospitalEmailSettings[0]);
        log("✅ Email settings loaded", hospitalEmailSettings[0]);
        return;
      }
    }

    // Reset to initial state if no settings are found after loading
    if (!emailSettingLoading) {
      setEmailServiceSettings((prev) => ({
        ...prev,
        service: "gmail",
        user: "",
        pass: "",
        is_enabled: "0",
        hid: currentHospitalId,
        use_own_credentials: 0,
      }));
    }
     if (twilioSmsSettings && twilioSmsSettings.length > 0) {
      const hospitalTwilio = twilioSmsSettings.filter(
        (setting) => String(setting.hid) === currentHospitalId
      );
      if (hospitalTwilio.length > 0) {
        setTwilioSettings(hospitalTwilio[0]);
      }
    }


    if (msgClubSmsSettings && msgClubSmsSettings.length > 0) {
      // Filter SMS settings for current hospital
      const hospitalSmsSettings = msgClubSmsSettings.filter(
        (setting) =>
          String(setting.hid || setting.hospitalID) === currentHospitalId,
      );
      if (hospitalSmsSettings.length > 0) {
        setSmsServiceSettings(hospitalSmsSettings[0]);
        log("✅ SMS settings loaded", hospitalSmsSettings[0]);
        return;
      }
    }

    // Reset to initial state if no settings are found after loading
    if (!msgClubSmsSettingLoading) {
      setSmsServiceSettings((prev) => ({
        ...prev,
        field1: "",
        field2: "",
        field3: "",
        hid: currentHospitalId,
      }));
    }
  }, [
    emailSettings,
    msgClubSmsSettings,
    currentHospitalId,
    log,
    emailSettingLoading,
    msgClubSmsSettingLoading,
  ]);

  // Debug effect to check notifications
  useEffect(() => {
    log("📊 Notification Data Debug", {
      allNotifications: notificationSettings?.length,
      hospitalNotifications: hospitalNotificationSettings?.length,
      emailNotifications: emailNotifications?.length,
      smsNotifications: smsNotifications?.length,
      currentHospitalId,
    });
  }, [
    notificationSettings,
    hospitalNotificationSettings,
    emailNotifications,
    smsNotifications,
    currentHospitalId,
    log,
  ]);

  // ==================== DATA LOADING ====================

  const loadAllData = useCallback(() => {
    const hospitalId = getHospitalId();
    log("🔄 Loading all notification data");
    // The actions are now expected to resolve to [] on error, preventing crash
    dispatch(getAllEmailSettings(hospitalId));
      dispatch(getAllTwilioSmsSettings(hospitalId));
    dispatch(getAllMsgClubSmsSettings(hospitalId));
    dispatch(getAllNotificationSettings(hospitalId));
  }, [dispatch, getHospitalId, log]);

  // ==================== HANDLER FUNCTIONS ====================

  const handleSmsChange = useCallback((field, value) => {
    setSmsServiceSettings((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleEmailServiceChange = useCallback((field, value) => {
    setEmailServiceSettings((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleEmailNotificationChange = useCallback((field, value) => {
    setEmailNotification((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleSmsNotificationChange = useCallback((field, value) => {
    setSmsNotification((prev) => ({ ...prev, [field]: value }));
  }, []);

  // ==================== API SUBMISSION HANDLERS ====================
// --- TWILIO HANDLERS ---
const handleEditTwilio = (setting) => {
  setSmsProvider("twilio");
  setTwilioSettings({
    ...setting,
    hid: String(setting.hid)
  });
  setEditingNotification(setting.id); // Reusing this state for ID tracking
  setEditingType("twilio_provider");
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const handleDeleteTwilio = (id) => {
  showConfirmation(
    "Delete Twilio Setting",
    "Are you sure you want to delete this configuration?",
    async () => {
      await dispatch(deleteTwilioSmsSetting(id));
      showSuccess("Twilio setting deleted!");
      dispatch(getAllTwilioSmsSettings(currentHospitalId));
    }
  );
};

// --- MSGCLUB HANDLERS ---
const handleEditMsgClub = (setting) => {
  setSmsProvider("msgclub");
  setSmsServiceSettings({
    ...setting,
    hid: String(setting.hid)
  });
  setEditingNotification(setting.id);
  setEditingType("msgclub_provider");
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const handleDeleteMsgClub = (id) => {
  showConfirmation(
    "Delete MsgClub Setting",
    "Are you sure you want to delete this configuration?",
    async () => {
      await dispatch(deleteMsgClubSmsSetting(id));
      showSuccess("MsgClub setting deleted!");
      dispatch(getAllMsgClubSmsSettings(currentHospitalId));
    }
  );
};
  // Email Settings Submission
  // const handleEmailSettingSubmit = async (e) => {
  //   e.preventDefault();
  //   setModalLoading(true);

  //   try {
  //     const hospitalId = currentHospitalId;

  //     // Filter existing settings for current hospital
  //     const hospitalEmailSettings = emailSettings.filter(
  //       (setting) => String(setting.hid || setting.hospitalID) === hospitalId,
  //     );

  //     if (hospitalEmailSettings.length > 0) {
  //       // Update existing
  //       await dispatch(
  //         updateEmailSetting({
  //           ...emailServiceSettings,
  //           id: hospitalEmailSettings[0].id,
  //         }),
  //       );
  //       showSuccess("Email settings updated successfully!");
  //     } else {
  //       // Create new
  //       await dispatch(createEmailSetting(emailServiceSettings));
  //       showSuccess("Email settings created successfully!");
  //     }
  //     dispatch(getAllEmailSettings(hospitalId));
  //   } catch (error) {
  //     log("❌ Email settings save failed", error, "error");
  //     // Use local error state if action did not reject (unlikely with refactored actions)
  //     showError(
  //       `Failed to save email settings: ${emailSettingError || error.message}`,
  //     );
  //   } finally {
  //     setModalLoading(false);
  //   }
  // };
 const handleEmailSettingSubmit = async (e) => {
  e.preventDefault();
  setModalLoading(true);

  try {
    const payload = {
      ...emailServiceSettings,
      smtp_port: Number(emailServiceSettings.smtp_port), // Ensure it's a number
      smtp_secure: Number(emailServiceSettings.smtp_secure),
      is_enabled: Number(emailServiceSettings.is_enabled),
      hid: String(currentHospitalId)
    };

    const hospitalEmailSettings = emailSettings.filter(
      (setting) => String(setting.hid) === currentHospitalId
    );

    if (hospitalEmailSettings.length > 0) {
      await dispatch(updateEmailSetting({ ...payload, id: hospitalEmailSettings[0].id }));
      showSuccess("Email settings updated successfully!");
    } else {
      await dispatch(createEmailSetting(payload));
      showSuccess("Email settings created successfully!");
    }
    dispatch(getAllEmailSettings(currentHospitalId));
  } catch (error) {
    showError(error.message);
  } finally {
    setModalLoading(false);
  }
};
// --- EMAIL SETTINGS HANDLERS ---
const handleEditEmail = (setting) => {
  setEmailServiceSettings({
    ...setting,
    hid: String(setting.hid)
  });
  setEditingNotification(setting.id); 
  setEditingType("email_provider");
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// const handleDeleteEmail = (id) => {
//   showConfirmation(
//     "Delete Email Setting",
//     "Are you sure you want to delete this SMTP configuration?",
//     async () => {
//       // Note: Ensure deleteEmailSetting is imported and exists in actions
//       await dispatch(deleteEmailSetting(id));
//       showSuccess("Email setting deleted!");
//       dispatch(getAllEmailSettings(currentHospitalId));
//     }
//   );
// };
const handleDeleteEmail = (id) => {
  showConfirmation(
    "Delete Email Setting",
    "Are you sure you want to delete this SMTP configuration?",
    async () => {
      try {
        setModalLoading(true);
        
        // Yaha 'id' aur 'currentHospitalId' dono dispatch karein
        await dispatch(deleteEmailSetting(id, currentHospitalId)); 
        
        showSuccess("Email setting deleted successfully!");
        
        // Delete ke baad list ko refresh karein
        dispatch(getAllEmailSettings(currentHospitalId)); 
      } catch (error) {
        showError("Failed to delete: " + error.message);
      } finally {
        setModalLoading(false);
      }
    }
  );
};
const prepareNotificationPayload = (data, type, existingNotification = null) => {
  const oldSms = existingNotification?.sms || {};
  const oldEmail = existingNotification?.email || {};

  return {
    hospitalID: String(data.hospitalID),
    EventKey: data.EventKey,
    Event: data.Event,
    // Agar existing notification hai to uska status lo, nahi to form data se lo
    IsEmailEnabled: Number(data.IsEmailEnabled),
    IsSmsEnabled: Number(data.IsSmsEnabled),
    IsAppEnabled: 0,
    IsSystemDefined: 1,
    sms: {
      sms_type: type === "sms" ? (data.sms_type) : (oldSms.sms_type || "false"),
      SampleMessage: type === "sms" ? data.SampleMessage : (oldSms.SampleMessage || "false"),
      dlt_entity_id: type === "sms" ? data.dlt_entity_id : (oldSms.dlt_entity_id || "false"),
      dlt_template_id: type === "sms" ? data.dlt_template_id : (oldSms.dlt_template_id || "false"),
      sender_id: type === "sms" ? data.sender_id : (oldSms.sender_id || "false"),
    },
    email: {
      EmailSubject: type === "email" ? data.EmailSubject : (oldEmail.EmailSubject || "false"),
      EmailBody: type === "email" ? data.EmailBody : (oldEmail.EmailBody || "false"),
    },
    app: { AppMessage: null }
  };
};
  // SMS Settings Submission
  // const handleSmsSettingSubmit = async (e) => {
  //   e.preventDefault();
  //   setModalLoading(true);

  //   try {
  //     const hospitalId = currentHospitalId;

  //     // Filter existing settings for current hospital
  //     const hospitalSmsSettings = msgClubSmsSettings.filter(
  //       (setting) => String(setting.hid || setting.hospitalID) === hospitalId,
  //     );

  //     if (hospitalSmsSettings.length > 0) {
  //       // Update existing
  //       await dispatch(
  //         updateMsgClubSmsSetting({
  //           ...smsServiceSettings,
  //           id: hospitalSmsSettings[0].id,
  //         }),
  //       );
  //       showSuccess("SMS settings updated successfully!");
  //     } else {
  //       // Create new
  //       await dispatch(createMsgClubSmsSetting(smsServiceSettings));
  //       showSuccess("SMS settings created successfully!");
  //     }
  //     dispatch(getAllMsgClubSmsSettings(hospitalId));
  //   } catch (error) {
  //     log("❌ SMS settings save failed", error, "error");
  //     showError(
  //       `Failed to save SMS settings: ${msgClubSmsSettingError || error.message}`,
  //     );
  //   } finally {
  //     setModalLoading(false);
  //   }
  // };
const handleSmsSettingSubmit = async (e) => {
    e.preventDefault();
    setModalLoading(true);
    try {
        if (smsProvider === "twilio") {
            const existing = twilioSmsSettings.find(s => String(s.hid) === currentHospitalId);
            if (existing) {
                await dispatch(updateTwilioSmsSetting({ ...twilioSettings, id: existing.id }));
            } else {
                await dispatch(createTwilioSmsSetting(twilioSettings));
            }
            dispatch(getAllTwilioSmsSettings(currentHospitalId));
        } else {
            const existing = msgClubSmsSettings.find(s => String(s.hid) === currentHospitalId);
            if (existing) {
                await dispatch(updateMsgClubSmsSetting({ ...smsServiceSettings, id: existing.id }));
            } else {
                await dispatch(createMsgClubSmsSetting(smsServiceSettings));
            }
            dispatch(getAllMsgClubSmsSettings(currentHospitalId));
        }
        showSuccess(`${smsProvider.toUpperCase()} settings saved!`);
    } catch (err) {
        showError(err.message);
    } finally {
        setModalLoading(false);
    }
};
  // Email Notification Submission
  // const handleEmailNotificationSubmit = async (e) => {
  //   e.preventDefault();
  //   setModalLoading(true);

  //   try {
  //     // Prepare email-specific data with other fields set to false
  //     const emailData = {
  //       Event: emailNotification.Event,
  //       Email: "true",
  //       SMS: "false",
  //       sms_type: "false",
  //       App: "false",
  //       SampleMessage: "false",
  //       EmailSubject: emailNotification.EmailSubject,
  //       EmailBody: emailNotification.EmailBody,
  //       hospitalID: currentHospitalId,
  //       dlt_entity_id: "false",
  //       dlt_template_id: "false",
  //       sender_id: "false",
  //     };

  //     if (editingNotification && editingType === "email") {
  //       // Update existing email notification using Redux action
  //       await dispatch(
  //         updateNotificationSetting({
  //           ...emailData,
  //           id: editingNotification,
  //         }),
  //       );
  //       showSuccess("Email notification updated successfully!");
  //       setEditingNotification(null);
  //       setEditingType("");
  //     } else {
  //       // Create new email notification using Redux action
  //       await dispatch(createNotificationSetting(emailData));
  //       showSuccess("Email notification created successfully!");
  //     }
  //     // Reset form
  //     setEmailNotification({
  //       Event: "",
  //       Email: "true",
  //       SMS: "false",
  //       sms_type: "false",
  //       App: "false",
  //       SampleMessage: "false",
  //       EmailSubject: "",
  //       EmailBody: "",
  //       hospitalID: currentHospitalId,
  //       dlt_entity_id: "false",
  //       dlt_template_id: "false",
  //       sender_id: "false",
  //     });
  //     // Reload notifications using Redux action
  //     dispatch(getAllNotificationSettings(currentHospitalId));
  //   } catch (error) {
  //     log("❌ Email notification save failed", error, "error");
  //     showError(
  //       `Failed to save email notification: ${notificationSettingError || error.message}`,
  //     );
  //   } finally {
  //     setModalLoading(false);
  //   }
  // };
  const handleEmailNotificationSubmit = async (e) => {
  e.preventDefault();
  setModalLoading(true);
  try {
    // Editing waqt poora object dhundo taaki SMS data loss na ho
    const existing = notificationSettings.find(n => n.id === editingNotification);
    const payload = prepareNotificationPayload(emailNotification, "email", existing);

    if (editingNotification) {
      await dispatch(updateNotificationSetting({ ...payload, id: editingNotification }));
      showSuccess("Email details added/updated successfully!");
    } else {
      await dispatch(createNotificationSetting(payload));
      showSuccess("Notification created!");
    }
  
    
    // फॉर्म को खाली करना
    setEmailNotification({
      Event: "",
      EventKey: "",
      EmailSubject: "",
      EmailBody: "",
      hospitalID: currentHospitalId,
    });
    setEditingNotification(null);
    dispatch(getAllNotificationSettings(currentHospitalId));
  } catch (error) {
    showError(`Error: ${error.message}`);
  } finally {
    setModalLoading(false);
  }
};
  // SMS Notification Submission
  // const handleSmsNotificationSubmit = async (e) => {
  //   e.preventDefault();
  //   setModalLoading(true);

  //   try {
  //     // Prepare SMS-specific data with other fields set to false
  //     const smsData = {
  //       Event: smsNotification.Event,
  //       Email: "false",
  //       SMS: "true",
  //       sms_type: smsNotification.sms_type,
  //       App: "false",
  //       SampleMessage: smsNotification.SampleMessage,
  //       EmailSubject: "false",
  //       EmailBody: "false",
  //       hospitalID: currentHospitalId,
  //       dlt_entity_id: smsNotification.dlt_entity_id,
  //       dlt_template_id: smsNotification.dlt_template_id,
  //       sender_id: smsNotification.sender_id,
  //     };

  //     if (editingNotification && editingType === "sms") {
  //       // Update existing SMS notification using Redux action
  //       await dispatch(
  //         updateNotificationSetting({
  //           ...smsData,
  //           id: editingNotification,
  //         }),
  //       );
  //       showSuccess("SMS notification updated successfully!");
  //       setEditingNotification(null);
  //       setEditingType("");
  //     } else {
  //       // Create new SMS notification using Redux action
  //       await dispatch(createNotificationSetting(smsData));
  //       showSuccess("SMS notification created successfully!");
  //     }
  //     // Reset form
  //     setSmsNotification({
  //       Event: "",
  //       Email: "false",
  //       SMS: "true",
  //       sms_type: "transactional",
  //       App: "false",
  //       SampleMessage: "",
  //       EmailSubject: "false",
  //       EmailBody: "false",
  //       hospitalID: currentHospitalId,
  //       dlt_entity_id: "",
  //       dlt_template_id: "",
  //       sender_id: "",
  //     });
  //     // Reload notifications using Redux action
  //     dispatch(getAllNotificationSettings(currentHospitalId));
  //   } catch (error) {
  //     log("❌ SMS notification save failed", error, "error");
  //     showError(
  //       `Failed to save SMS notification: ${notificationSettingError || error.message}`,
  //     );
  //   } finally {
  //     setModalLoading(false);
  //   }
  // };
const handleSmsNotificationSubmit = async (e) => {
  e.preventDefault();
  setModalLoading(true);

  try {
    // API के लिए नेस्टेड पेलोड तैयार करना
    const payload = prepareNotificationPayload(smsNotification, "sms");

    if (editingNotification && editingType === "sms") {
      await dispatch(updateNotificationSetting({ ...payload, id: editingNotification }));
      showSuccess("SMS notification updated successfully!");
    } else {
      await dispatch(createNotificationSetting(payload));
      showSuccess("SMS notification created successfully!");
    }

    // फॉर्म को खाली करना
    setSmsNotification({
      Event: "",
      EventKey: "",
      sms_type: "transactional",
      SampleMessage: "",
      dlt_entity_id: "",
      dlt_template_id: "",
      sender_id: "",
      hospitalID: currentHospitalId,
    });
    setEditingNotification(null);
    dispatch(getAllNotificationSettings(currentHospitalId));
  } catch (error) {
    showError(`Error: ${error.message}`);
  } finally {
    setModalLoading(false);
  }
};
  // ==================== EDIT HANDLERS ====================

  // const handleEditNotification = useCallback(
  //   (notification) => {
  //     // Use the robust checker for determining type
  //     const type = isTrueValue(notification.Email) ? "email" : "sms";

  //     log("✏️ Editing notification", { notification, type });

  //     if (type === "email") {
  //       setEmailNotification({
  //         ...notification,
  //         id: notification.id,
  //         // Ensure hospitalID is correctly set for update payload
  //         hospitalID: String(notification.hospitalID || currentHospitalId),
  //       });
  //     } else {
  //       setSmsNotification({
  //         ...notification,
  //         id: notification.id,
  //         // Ensure hospitalID is correctly set for update payload
  //         hospitalID: String(notification.hospitalID || currentHospitalId),
  //       });
  //     }

  //     setEditingNotification(notification.id);
  //     setEditingType(type);
  //   },
  //   [log, currentHospitalId],
  // );
const handleEditNotification = useCallback((notification) => {
  log("✏️ Editing notification", { id: notification.id });

  // common data for both
  const commonData = {
    id: notification.id,
    Event: notification.Event || "",
    EventKey: notification.EventKey || "",
    hospitalID: String(notification.hospitalID),
    IsEmailEnabled: notification.IsEmailEnabled,
    IsSmsEnabled: notification.IsSmsEnabled,
    originalData: notification 
  };

  if (notificationTypeTab === "sms") {
    setSmsNotification({
      ...commonData,
      sms_type: notification.sms?.sms_type || "transactional",
      SampleMessage: notification.sms?.SampleMessage || "",
      dlt_entity_id: notification.sms?.dlt_entity_id || "",
      dlt_template_id: notification.sms?.dlt_template_id || "",
      sender_id: notification.sms?.sender_id || "",
    });
  } else {
    setEmailNotification({
      ...commonData,
      EmailSubject: notification.email?.EmailSubject || "",
      EmailBody: notification.email?.EmailBody || "",
    });
  }

  setEditingNotification(notification.id);

  // --- AUTOMATIC SCROLL LOGIC ---
  setTimeout(() => {
    const element = document.getElementById("notification-form-top");
    if (element) {
      element.scrollIntoView({ 
        behavior: "smooth", 
        block: "start" 
      });
    } else {
      // Fallback: Agar ID nahi mili toh top par scroll karein
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, 100); // 100ms ka delay taaki state render ho jaye

}, [notificationTypeTab, log]);
  const handleCancelEdit = useCallback(() => {
    log("❌ Cancelling edit");
    setEmailNotification({
      Event: "",
      Email: "true",
      SMS: "false",
      sms_type: "false",
      App: "false",
      SampleMessage: "false",
      EmailSubject: "",
      EmailBody: "",
      hospitalID: currentHospitalId,
      dlt_entity_id: "false",
      dlt_template_id: "false",
      sender_id: "false",
    });
    setSmsNotification({
      Event: "",
      Email: "false",
      SMS: "true",
      sms_type: "transactional",
      App: "false",
      SampleMessage: "",
      EmailSubject: "false",
      EmailBody: "false",
      hospitalID: currentHospitalId,
      dlt_entity_id: "",
      dlt_template_id: "",
      sender_id: "",
    });
    setEditingNotification(null);
    setEditingType("");
  }, [currentHospitalId, log]);

  // ==================== DELETE HANDLER ====================

  const handleDeleteNotification = useCallback(
    (id) => {
      log("🗑️ Delete notification requested", { id });
      setPendingDeleteId(id);
      showConfirmation(
        "Confirm Deletion",
        "Are you sure you want to delete this notification setting? This action cannot be undone.",
        () => confirmDeleteNotification(id),
      );
    },
    [showConfirmation, log],
  );
const handleChannelSpecificDelete = useCallback((notification, channelType) => {
  const isEmail = channelType === "email";
  
  // 1. Check karein ki kya doosra channel (SMS/Email) active hai?
  const isOtherChannelActive = isEmail 
    ? Number(notification.IsSmsEnabled) === 1 
    : Number(notification.IsEmailEnabled) === 1;

  // 2. Title aur Message tay karein logic ke hisaab se
  const title = isOtherChannelActive 
    ? `Remove ${isEmail ? 'Email' : 'SMS'} Details` 
    : "Delete Entire Notification";

  const message = isOtherChannelActive
    ? `Are you sure? This will clear ${isEmail ? 'Email' : 'SMS'} details but keep the other channel active.`
    : "Since no other channel (SMS/Email) is active for this event, this will completely delete the notification. Continue?";

  showConfirmation(title, message, async () => {
    setModalLoading(true);
    try {
      if (isOtherChannelActive) {
        // CASE A: Doosra channel active hai -> Sirf UPDATE karein (fields clear karein)
        const payload = {
          id: notification.id,
          hospitalID: String(notification.hospitalID),
          Event: notification.Event,
          EventKey: notification.EventKey,
          IsAppEnabled: 0,
          IsSystemDefined: 1,
          IsEmailEnabled: isEmail ? 0 : notification.IsEmailEnabled,
          IsSmsEnabled: !isEmail ? 0 : notification.IsSmsEnabled,
          email: {
            EmailSubject: isEmail ? "false" : (notification.email?.EmailSubject || "false"),
            EmailBody: isEmail ? "false" : (notification.email?.EmailBody || "false"),
          },
          sms: {
            sms_type: !isEmail ? "false" : (notification.sms?.sms_type || "false"),
            SampleMessage: !isEmail ? "false" : (notification.sms?.SampleMessage || "false"),
            dlt_entity_id: !isEmail ? "false" : (notification.sms?.dlt_entity_id || "false"),
            dlt_template_id: !isEmail ? "false" : (notification.sms?.dlt_template_id || "false"),
            sender_id: !isEmail ? "false" : (notification.sms?.sender_id || "false"),
          },
          app: { AppMessage: null }
        };
        await dispatch(updateNotificationSetting(payload));
        showSuccess(`${isEmail ? 'Email' : 'SMS'} details removed.`);
      } else {
        // CASE B: Dono channels khatam ho rahe hain -> Poori Row DELETE karein
        await dispatch(deleteNotificationSetting(notification.id, currentHospitalId));
        showSuccess("Notification event deleted completely.");
      }
      
      // Data refresh karein
      dispatch(getAllNotificationSettings(currentHospitalId));
    } catch (error) {
      showError("Action failed: " + error.message);
    } finally {
      setModalLoading(false);
    }
  });
}, [dispatch, currentHospitalId, showConfirmation, showSuccess, showError]);
  // const confirmDeleteNotification = async (id) => {
  //   setModalLoading(true);
  //   try {
  //     await dispatch(deleteNotificationSetting(id));
  //     showSuccess("Notification setting deleted successfully!");
  //     dispatch(getAllNotificationSettings(currentHospitalId));
  //   } catch (error) {
  //     log("❌ Delete notification failed", error, "error");
  //     showError(
  //       `Failed to delete notification setting: ${notificationSettingError || error.message}`,
  //     );
  //   } finally {
  //     setModalLoading(false);
  //     setPendingDeleteId(null);
  //   }
  // };

  // ==================== RESET FUNCTION ====================
const confirmDeleteNotification = async (id) => {
    setModalLoading(true);
    try {
     
      const deletePayload = {
        "id": Number(id),        
        "hospitalID": String(currentHospitalId) 
      };

      console.log("Deleting with Payload:", JSON.stringify(deletePayload));

      await dispatch(deleteNotificationSetting(id, currentHospitalId));
      
      showSuccess("Notification setting deleted successfully!");
      dispatch(getAllNotificationSettings(currentHospitalId));
    } catch (error) {
      log("❌ Delete notification failed", error, "error");
      showError(
        `Failed to delete notification setting: ${notificationSettingError || error.message}`,
      );
    } finally {
      setModalLoading(false);
      setPendingDeleteId(null);
    }
};
  const resetToDefault = useCallback(() => {
    showConfirmation(
      "Confirm Reset",
      "Are you sure you want to reset all forms to default values? This will clear all unsaved changes.",
      () => confirmResetToDefault(),
    );
  }, [showConfirmation]);

  const confirmResetToDefault = useCallback(() => {
    log("🔄 Resetting all forms to default");
    setSmsServiceSettings({
      field1: "",
      field2: "",
      field3: "",
      hid: currentHospitalId,
    });
    setEmailServiceSettings({
      service: "gmail",
      user: "",
      pass: "",
      is_enabled: "0",
      hid: currentHospitalId,
      use_own_credentials: 0,
    });
    setEmailNotification({
      Event: "",
      Email: "true",
      SMS: "false",
      sms_type: "false",
      App: "false",
      SampleMessage: "false",
      EmailSubject: "",
      EmailBody: "",
      hospitalID: currentHospitalId,
      dlt_entity_id: "false",
      dlt_template_id: "false",
      sender_id: "false",
    });
    setSmsNotification({
      Event: "",
      Email: "false",
      SMS: "true",
      sms_type: "transactional",
      App: "false",
      SampleMessage: "",
      EmailSubject: "false",
      EmailBody: "false",
      hospitalID: currentHospitalId,
      dlt_entity_id: "",
      dlt_template_id: "",
      sender_id: "",
    });
    setEditingNotification(null);
    setEditingType("");
    dispatch(resetNotificationState());
    showSuccess("All forms reset to default values!");
  }, [currentHospitalId, dispatch, showSuccess, log]);

  // ==================== RENDER FUNCTIONS ====================

  // Render Email Settings Tab
  // const renderEmailSettingsTab = () => (
  //   <div className="tab-pane fade show active">
  //     <h3 className="mb-4 text-primary">Email Service Settings</h3>
  //     <form onSubmit={handleEmailSettingSubmit}>
  //       <div className="row">
  //         <div className="col-md-6">
  //           <div className="mb-3">
  //             <label className="form-label">Service</label>
  //             <select
  //               className="form-select"
  //               value={emailServiceSettings.service}
  //               onChange={(e) =>
  //                 handleEmailServiceChange("service", e.target.value)
  //               }
  //               disabled={modalLoading}
  //             >
  //               <option value="gmail">Gmail</option>
  //               <option value="outlook">Outlook</option>
  //               <option value="yahoo">Yahoo</option>
  //               <option value="smtp">Custom SMTP</option>
  //             </select>
  //           </div>
  //           <div className="mb-3">
  //             <label className="form-label">User/Email *</label>
  //             <input
  //               type="email"
  //               className="form-control"
  //               value={emailServiceSettings.user}
  //               onChange={(e) =>
  //                 handleEmailServiceChange("user", e.target.value)
  //               }
  //               required
  //               disabled={modalLoading}
  //             />
  //           </div>
  //         </div>
  //         <div className="col-md-6">
  //           <div className="mb-3">
  //             <label className="form-label">Password *</label>
  //             <input
  //               type="TEXT"
  //               className="form-control"
  //               value={emailServiceSettings.pass}
  //               onChange={(e) =>
  //                 handleEmailServiceChange("pass", e.target.value)
  //               }
  //               required
  //               disabled={modalLoading}
  //             />
  //           </div>
  //           <div className="mb-3">
  //             <label className="form-label">Status</label>
  //             <select
  //               className="form-select"
  //               value={emailServiceSettings.is_enabled}
  //               onChange={(e) =>
  //                 handleEmailServiceChange("is_enabled", e.target.value)
  //               }
  //               disabled={modalLoading}
  //             >
  //               <option value="0">Disabled</option>
  //               <option value="1">Enabled</option>
  //             </select>
  //           </div>
  //         </div>
  //       </div>

  //       {emailSettingError && (
  //         <div className="alert alert-danger my-3">
  //           <i className="fas fa-exclamation-triangle me-2"></i>
  //           **Error loading/saving:** {emailSettingError}
  //         </div>
  //       )}

  //       <div className="d-flex gap-2 justify-content-end border-top pt-3">
  //         <button
  //           type="submit"
  //           className="update-button"
  //           disabled={emailSettingLoading || modalLoading}
  //         >
  //           {emailSettingLoading || modalLoading ? (
  //             <>
  //               <span className="spinner-border spinner-border-sm me-2"></span>
  //               Saving...
  //             </>
  //           ) : hasEmailSettings ? (
  //             "Update Email Settings"
  //           ) : (
  //             "Save Email Settings"
  //           )}
  //         </button>
  //       </div>
  //     </form>
  //   </div>
  // );
const renderEmailSettingsTab = () => {
  // Filter settings for current hospital
  const filteredEmails = emailSettings.filter(s => String(s.hid) === currentHospitalId);

  return (
    <div className="tab-pane fade show active">
      <h3 className="mb-4 text-primary">Email Service Settings</h3>

      {/* Toggle Pills - Consistent with Notification UI */}
      <ul className="nav nav-pills mb-4">
        <li className="nav-item">
          <button
            className={`nav-link bg-info rounded-pill active view-button`}
            disabled={modalLoading}
          >
            SMTP Configuration
          </button>
        </li>
      </ul>

      {/* CREATE / EDIT FORM CARD */}
      <div className="card mb-4">
        <div className="card-header bg-light">
          <h5 className="mb-0">
            {editingNotification && editingType === "email_provider"
              ? "Edit SMTP Configuration"
              : "Add New SMTP Configuration"}
          </h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleEmailSettingSubmit}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Provider Type</label>
                <select
                  className="form-select"
                  value={emailServiceSettings.provider_type}
                  onChange={(e) => handleEmailServiceChange("provider_type", e.target.value)}
                  disabled={modalLoading}
                >
                  <option value="smtp">Custom SMTP</option>
                  <option value="gmail">Gmail</option>
                  <option value="outlook">Outlook</option>
                </select>
              </div>
              <div className="col-md-5 mb-3">
                <label className="form-label fw-bold">SMTP Host *</label>
                <input
                  type="text"
                  className="form-control"
                  value={emailServiceSettings.smtp_host}
                  onChange={(e) => handleEmailServiceChange("smtp_host", e.target.value)}
                  required
                  disabled={modalLoading}
                  placeholder="smtp.example.com"
                />
              </div>
              <div className="col-md-3 mb-3">
                <label className="form-label fw-bold">SMTP Port *</label>
                <input
                  type="number"
                  className="form-control"
                  value={emailServiceSettings.smtp_port}
                  onChange={(e) => handleEmailServiceChange("smtp_port", e.target.value)}
                  required
                  disabled={modalLoading}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">SMTP Username *</label>
                <input
                  type="email"
                  className="form-control"
                  value={emailServiceSettings.smtp_user}
                  onChange={(e) => handleEmailServiceChange("smtp_user", e.target.value)}
                  required
                  disabled={modalLoading}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">SMTP Password *</label>
                <input
                  type="password"
                  autoComplete="new-password"
                  className="form-control"
                  value={emailServiceSettings.smtp_pass}
                  onChange={(e) => handleEmailServiceChange("smtp_pass", e.target.value)}
                  required
                  disabled={modalLoading}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">From Email Address *</label>
                <input
                  type="email"
                  className="form-control"
                  value={emailServiceSettings.from_email}
                  onChange={(e) => handleEmailServiceChange("from_email", e.target.value)}
                  required
                  disabled={modalLoading}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold">From Name (Display)</label>
                <input
                  type="text"
                  className="form-control"
                  value={emailServiceSettings.from_name}
                  onChange={(e) => handleEmailServiceChange("from_name", e.target.value)}
                  disabled={modalLoading}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">SMTP Secure</label>
                <select
                  className="form-select"
                  value={emailServiceSettings.smtp_secure}
                  onChange={(e) => handleEmailServiceChange("smtp_secure", e.target.value)}
                  disabled={modalLoading}
                >
                  <option value="0">No (Plain)</option>
                  <option value="1">Yes (SSL/TLS)</option>
                </select>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Status</label>
                <select
                  className="form-select"
                  value={emailServiceSettings.is_enabled}
                  onChange={(e) => handleEmailServiceChange("is_enabled", e.target.value)}
                  disabled={modalLoading}
                >
                  <option value="1">Enabled</option>
                  <option value="0">Disabled</option>
                </select>
              </div>
            </div>

            <div className="d-flex gap-2 justify-content-end border-top pt-3">
              {editingNotification && editingType === "email_provider" && (
                <button
                  type="button"
                  className="filter-button"
                  onClick={() => { setEditingNotification(null); setEditingType(""); }}
                  disabled={modalLoading}
                >
                  Cancel Edit
                </button>
              )}
              <button
                type="submit"
                className="save-button"
                disabled={emailSettingLoading || modalLoading}
              >
                {emailSettingLoading || modalLoading ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Saving...</>
                ) : editingNotification && editingType === "email_provider" ? (
                  "Update Configuration"
                ) : (
                  "Save Configuration"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* EMAIL CONFIGURATION TABLE */}
      <div className="card">
        <div className="card-header bg-light">
          <h5 className="mb-0">SMTP Configuration List ({filteredEmails.length})</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Host</th>
                  <th>User</th>
                  <th>From Email</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredEmails.length > 0 ? (
                  filteredEmails.map((email) => (
                    <tr key={email.id}>
                      <td className="fw-bold">{email.id}</td>
                      <td>{email.smtp_host}</td>
                      <td>{email.smtp_user}</td>
                      <td>{email.from_email}</td>
                      <td>
                        <span className={`badge ${email.is_enabled === 1 || email.is_enabled === "1" ? "bg-success" : "bg-danger"}`}>
                          {email.is_enabled === 1 || email.is_enabled === "1" ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="i-btn-edit"
                            onClick={() => handleEditEmail(email)}
                            disabled={modalLoading}
                          ></button>
                          <button
                            type="button"
                            className="i-btn-delete"
                            onClick={() => handleDeleteEmail(email.id)}
                            disabled={modalLoading}
                          ></button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-3 text-muted">
                      No email configurations found for your hospital.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
  // Render SMS Settings Tab
  // const renderSmsSettingsTab = () => (
  //   <div className="tab-pane fade show active">
  //     <h3 className="mb-4 text-primary">SMS Service Settings</h3>
  //     <form onSubmit={handleSmsSettingSubmit}>
  //       <h5 className="text-secondary mb-3">SMS Configuration</h5>
  //       <div className="row">
  //         <div className="col-md-6">
  //           <div className="mb-3">
  //             <label className="form-label">URL</label>
  //             <input
  //               type="text"
  //               className="form-control"
  //               value={smsServiceSettings.field1}
  //               onChange={(e) => handleSmsChange("field1", e.target.value)}
  //               required
  //               disabled={modalLoading}
  //             />
  //             <div className="form-text">Enter the SMS service URL</div>
  //           </div>
  //           <div className="mb-3">
  //             <label className="form-label">Auth Token</label>
  //             <input
  //               type="text"
  //               className="form-control"
  //               value={smsServiceSettings.field2}
  //               onChange={(e) => handleSmsChange("field2", e.target.value)}
  //               required
  //               disabled={modalLoading}
  //             />
  //             <div className="form-text">Enter Auth Token</div>
  //           </div>
  //         </div>
  //         <div className="col-md-6">
  //           <div className="mb-3">
  //             <label className="form-label">Status</label>
  //             <select
  //               className="form-select"
  //               value={smsServiceSettings.field3}
  //               onChange={(e) => handleSmsChange("field3", e.target.value)}
  //               disabled={modalLoading}
  //             >
  //               <option value="active">Active</option>
  //               <option value="inactive">Inactive</option>
  //             </select>
  //             <div className="form-text">Set SMS service status</div>
  //           </div>
  //         </div>
  //       </div>

  //       {msgClubSmsSettingError && (
  //         <div className="alert alert-danger my-3">
  //           <i className="fas fa-exclamation-triangle me-2"></i>
  //           **Error loading/saving:** {msgClubSmsSettingError}
  //         </div>
  //       )}

  //       <div className="d-flex gap-2 justify-content-end border-top pt-3">
  //         <button
  //           type="submit"
  //           className="save-button"
  //           disabled={msgClubSmsSettingLoading || modalLoading}
  //         >
  //           {msgClubSmsSettingLoading || modalLoading ? (
  //             <>
  //               <span className="spinner-border spinner-border-sm me-2"></span>
  //               Saving...
  //             </>
  //           ) : hasSmsSettings ? (
  //             "Update SMS Settings"
  //           ) : (
  //             "Save SMS Settings"
  //           )}
  //         </button>
  //       </div>
  //     </form>
  //   </div>
  // );
// const renderSmsSettingsTab = () => (
//   <div className="tab-pane fade show active">
//     <h3 className="mb-4 text-primary">SMS Provider Settings</h3>

//     {/* Toggle Pills - Same as Notification Settings */}
//     <ul className="nav nav-pills mb-4">
//       <li className="nav-item">
//         <button
//           className={`nav-link bg-info rounded-pill ${smsProvider === "twilio" ? "active view-button" : "view-button"}`}
//           onClick={() => { setSmsProvider("twilio"); setEditingNotification(null); }}
//         >
//           Twilio Provider
//         </button>
//       </li>
//       <li className="nav-item">
//         <button
//           className={`nav-link bg-info rounded-pill ${smsProvider === "msgclub" ? "active view-button" : "view-button"}`}
//           onClick={() => { setSmsProvider("msgclub"); setEditingNotification(null); }}
//         >
//           MsgClub Provider
//         </button>
//       </li>
//     </ul>

//     {/* CREATE / EDIT FORM */}
//     <div className="card mb-4">
//       <div className="card-header">
//         <h5 className="mb-0">
//           {editingNotification ? `Edit ${smsProvider} Configuration` : `Add New ${smsProvider} Configuration`}
//         </h5>
//       </div>
//       <div className="card-body">
//         <form onSubmit={handleSmsSettingSubmit}>
//           <div className="row">
//             {smsProvider === "twilio" ? (
//               <>
//                 <div className="col-md-6 mb-3">
//                   <label className="form-label fw-bold">API URL (Field 1) *</label>
//                   <input type="text" className="form-control" value={twilioSettings.field1} onChange={(e) => setTwilioSettings({ ...twilioSettings, field1: e.target.value })} required />
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   <label className="form-label fw-bold">Provider Name (Field 2) *</label>
//                   <input type="text" className="form-control" value={twilioSettings.field2} onChange={(e) => setTwilioSettings({ ...twilioSettings, field2: e.target.value })} required />
//                 </div>
//                 <div className="col-md-4 mb-3">
//                   <label className="form-label fw-bold">Password (Field 3)</label>
//                   <input type="password" name="new-password" autocomplete="off" className="form-control" value={twilioSettings.field3} onChange={(e) => setTwilioSettings({ ...twilioSettings, field3: e.target.value })} />
//                 </div>
//                 <div className="col-md-4 mb-3">
//                   <label className="form-label fw-bold">API Key (Field 4)</label>
//                   <input type="text" className="form-control" value={twilioSettings.field4} onChange={(e) => setTwilioSettings({ ...twilioSettings, field4: e.target.value })} />
//                 </div>
//                 <div className="col-md-4 mb-3">
//                   <label className="form-label fw-bold">Status (Field 5)</label>
//                   <select className="form-select" value={twilioSettings.field5} onChange={(e) => setTwilioSettings({ ...twilioSettings, field5: e.target.value })}>
//                     <option value="1">Active</option>
//                     <option value="0">Inactive</option>
//                   </select>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="col-md-6 mb-3">
//                   <label className="form-label fw-bold">MsgClub API URL *</label>
//                   <input type="text" className="form-control" value={smsServiceSettings.field1} onChange={(e) => setSmsServiceSettings({ ...smsServiceSettings, field1: e.target.value })} required />
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   <label className="form-label fw-bold">Auth Name *</label>
//                   <input type="text" className="form-control" value={smsServiceSettings.field2} onChange={(e) => setSmsServiceSettings({ ...smsServiceSettings, field2: e.target.value })} required />
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   <label className="form-label fw-bold">Status Code</label>
//                   <input type="text" className="form-control" value={smsServiceSettings.field3} onChange={(e) => setSmsServiceSettings({ ...smsServiceSettings, field3: e.target.value })} />
//                 </div>
//               </>
//             )}
//           </div>
//           <div className="d-flex justify-content-end gap-2 border-top pt-3">
//             {editingNotification && (
//               <button type="button" className="filter-button" onClick={() => setEditingNotification(null)}>Cancel</button>
//             )}
//             <button type="submit" className="save-button">
//               {editingNotification ? "Update Configuration" : "Save Configuration"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>

//     {/* LIST TABLE - Similar to Notification Table */}
//     <div className="card">
//       <div className="card-header bg-light">
//         <h5 className="mb-0">{smsProvider.toUpperCase()} Provider List</h5>
//       </div>
//       <div className="card-body">
//         <div className="table-responsive">
//           <table className="table table-striped table-hover">
//             <thead>
//               {smsProvider === "twilio" ? (
//                 <tr>
//                   <th>ID</th>
//                   <th>Name</th>
//                   <th>URL</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               ) : (
//                 <tr>
//                   <th>ID</th>
//                   <th>Auth Name</th>
//                   <th>URL</th>
//                   <th>Status Code</th>
//                   <th>Actions</th>
//                 </tr>
//               )}
//             </thead>
//             <tbody>
//               {smsProvider === "twilio" ? (
//                 twilioSmsSettings.length > 0 ? twilioSmsSettings.map((s) => (
//                   <tr key={s.id}>
//                     <td>{s.id}</td>
//                     <td>{s.field2}</td>
//                     <td><small className="text-muted">{s.field1}</small></td>
//                     <td><span className={`badge ${s.field5 === "1" ? "bg-success" : "bg-danger"}`}>{s.field5 === "1" ? "Active" : "Inactive"}</span></td>
//                     <td>
//                       <div className="btn-group btn-group-sm">
//                         <button className="i-btn-edit" onClick={() => handleEditTwilio(s)}></button>
//                         <button className="i-btn-delete" onClick={() => handleDeleteTwilio(s.id)}></button>
//                       </div>
//                     </td>
//                   </tr>
//                 )) : <tr><td colSpan="5" className="text-center">No Twilio settings found</td></tr>
//               ) : (
//                 msgClubSmsSettings.length > 0 ? msgClubSmsSettings.map((s) => (
//                   <tr key={s.id}>
//                     <td>{s.id}</td>
//                     <td>{s.field2}</td>
//                     <td><small className="text-muted">{s.field1}</small></td>
//                     <td>{s.field3}</td>
//                     <td>
//                       <div className="btn-group btn-group-sm">
//                         <button className="i-btn-edit" onClick={() => handleEditMsgClub(s)}></button>
//                         <button className="i-btn-delete" onClick={() => handleDeleteMsgClub(s.id)}></button>
//                       </div>
//                     </td>
//                   </tr>
//                 )) : <tr><td colSpan="5" className="text-center">No MsgClub settings found</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   </div>
// );
const renderSmsSettingsTab = () => {
  // Filter settings by current hospital ID to show only relevant ones in table
  const filteredTwilio = twilioSmsSettings.filter(s => String(s.hid) === currentHospitalId);
  const filteredMsgClub = msgClubSmsSettings.filter(s => String(s.hid) === currentHospitalId);

  return (
    <div className="tab-pane fade show active">
      <h3 className="mb-4 text-primary">SMS Service Configuration</h3>

      {/* Toggle Pills - Consistent with Notification Settings */}
      <ul className="nav nav-pills mb-4">
        <li className="nav-item">
          <button
            className={`nav-link bg-info rounded-pill ${smsProvider === "twilio" ? "active view-button" : "view-button"}`}
            onClick={() => { setSmsProvider("twilio"); setEditingNotification(null); }}
            disabled={modalLoading}
          >
            Twilio List
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link bg-info rounded-pill ${smsProvider === "msgclub" ? "active view-button" : "view-button"}`}
            onClick={() => { setSmsProvider("msgclub"); setEditingNotification(null); }}
            disabled={modalLoading}
          >
            MsgClub List
          </button>
        </li>
      </ul>

      {/* Create/Edit Provider Form - Same card style as Notification Form */}
      <div className="card mb-4">
        <div className="card-header bg-light">
          <h5 className="mb-0">
            {editingNotification 
              ? `Edit ${smsProvider === "twilio" ? "Twilio" : "MsgClub"} Settings` 
              : `Configure New ${smsProvider === "twilio" ? "Twilio" : "MsgClub"} Service`}
          </h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSmsSettingSubmit}>
            <div className="row">
              {smsProvider === "twilio" ? (
                <>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">API URL  *</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={twilioSettings.field1} 
                      onChange={(e) => setTwilioSettings({ ...twilioSettings, field1: e.target.value })} 
                      required 
                      disabled={modalLoading}
                      placeholder="https://api.twilio.com/..."
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Provider Name  *</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={twilioSettings.field2} 
                      onChange={(e) => setTwilioSettings({ ...twilioSettings, field2: e.target.value })} 
                      required 
                      disabled={modalLoading}
                      placeholder="e.g. Twilio Primary"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Password/Token </label>
                    <input 
                      type="password" 
                      autoComplete="new-password" 
                      className="form-control" 
                      value={twilioSettings.field3} 
                      onChange={(e) => setTwilioSettings({ ...twilioSettings, field3: e.target.value })} 
                      disabled={modalLoading}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">API Key </label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={twilioSettings.field4} 
                      onChange={(e) => setTwilioSettings({ ...twilioSettings, field4: e.target.value })} 
                      disabled={modalLoading}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Status </label>
                    <select 
                      className="form-select" 
                      value={twilioSettings.field5} 
                      onChange={(e) => setTwilioSettings({ ...twilioSettings, field5: e.target.value })}
                      disabled={modalLoading}
                    >
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                </>
              ) : (
                <>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">MsgClub API URL *</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={smsServiceSettings.field1} 
                      onChange={(e) => setSmsServiceSettings({ ...smsServiceSettings, field1: e.target.value })} 
                      required 
                      disabled={modalLoading}
                      placeholder="Enter MsgClub URL"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Auth Name (Field 2) *</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={smsServiceSettings.field2} 
                      onChange={(e) => setSmsServiceSettings({ ...smsServiceSettings, field2: e.target.value })} 
                      required 
                      disabled={modalLoading}
                      placeholder="Enter Auth Name"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Status Code (Field 3)</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={smsServiceSettings.field3} 
                      onChange={(e) => setSmsServiceSettings({ ...smsServiceSettings, field3: e.target.value })} 
                      disabled={modalLoading}
                      placeholder="e.g. 1 or active"
                    />
                  </div>
                </>
              )}
            </div>

            <div className="d-flex justify-content-end gap-2 border-top pt-3">
              {editingNotification && (
                <button 
                  type="button" 
                  className="filter-button" 
                  onClick={() => {
                    setEditingNotification(null);
                    setEditingType("");
                  }}
                  disabled={modalLoading}
                >
                  Cancel Edit
                </button>
              )}
              <button 
                type="submit" 
                className="save-button"
                disabled={modalLoading}
              >
                {modalLoading ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Saving...</>
                ) : editingNotification ? "Update Configuration" : "Save Configuration"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Provider List Table - Same style as Notification Tables */}
      <div className="card">
        <div className="card-header bg-light">
          <h5 className="mb-0">{smsProvider.toUpperCase()} Configuration List</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead>
                {smsProvider === "twilio" ? (
                  <tr>
                    <th>ID</th>
                    <th>Service Name</th>
                    <th>Endpoint URL</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                ) : (
                  <tr>
                    <th>ID</th>
                    <th>Auth Name</th>
                    <th>Endpoint URL</th>
                    <th>Status Code</th>
                    <th>Actions</th>
                  </tr>
                )}
              </thead>
              <tbody>
                {smsProvider === "twilio" ? (
                  filteredTwilio.length > 0 ? filteredTwilio.map((s) => (
                    <tr key={s.id}>
                      <td className="fw-bold">{s.id}</td>
                      <td>{s.field2}</td>
                      <td><small className="text-muted">{s.field1}</small></td>
                      <td>
                        <span className={`badge ${s.field5 === "1" ? "bg-success" : "bg-danger"}`}>
                          {s.field5 === "1" ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button className="i-btn-edit" title="Edit" onClick={() => handleEditTwilio(s)} disabled={modalLoading}></button>
                          <button className="i-btn-delete" title="Delete" onClick={() => handleDeleteTwilio(s.id)} disabled={modalLoading}></button>
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan="5" className="text-center py-3 text-muted">No Twilio configurations found.</td></tr>
                  )
                ) : (
                  filteredMsgClub.length > 0 ? filteredMsgClub.map((s) => (
                    <tr key={s.id}>
                      <td className="fw-bold">{s.id}</td>
                      <td>{s.field2}</td>
                      <td><small className="text-muted">{s.field1}</small></td>
                      <td><span className="badge bg-secondary">{s.field3 || "N/A"}</span></td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button className="i-btn-edit" title="Edit" onClick={() => handleEditMsgClub(s)} disabled={modalLoading}></button>
                          <button className="i-btn-delete" title="Delete" onClick={() => handleDeleteMsgClub(s.id)} disabled={modalLoading}></button>
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan="5" className="text-center py-3 text-muted">No MsgClub configurations found.</td></tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
  // Render Email Notifications
//   const renderEmailNotifications = () => (
//     <div>
//       {/* Create/Edit Email Notification Form */}
//       <div className="card mb-4">
//         <div className="card-header bg-light">
//           <h5 className="mb-0">
//             {editingNotification && editingType === "email"
//               ? "Edit Email Notification"
//               : "Create New Email Notification"}
//           </h5>
//         </div>
//         <div className="card-body">
//           <form onSubmit={handleEmailNotificationSubmit}>
//             <div className="row">
//               <div className="col-md-6">
//                 {/* <div className="mb-3">
//                   <label className="form-label">Event *</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={emailNotification.Event}
//                     onChange={(e) =>
//                       handleEmailNotificationChange("Event", e.target.value)
//                     }
//                     required
//                     disabled={modalLoading}
//                     placeholder="Enter event name"
//                   />
//                 </div> */}
//                 <div className="row">
//   <div className="col-md-6">
//     <label className="form-label">Event Name *</label>
//     <input
//       type="text"
//       className="form-control"
//       value={emailNotification.Event}
//       onChange={(e) => handleEmailNotificationChange("Event", e.target.value)}
//       required
//     />
//   </div>
//   <div className="col-md-6">
//   <div className="mb-3">
//     <label className="form-label fw-bold">Email Status</label>
//     <select
//       className="form-select"
//       value={emailNotification.IsEmailEnabled}
//       onChange={(e) => handleEmailNotificationChange("IsEmailEnabled", e.target.value)}
//     >
//       <option value={1}>Enabled (Active)</option>
//       <option value={0}>Disabled (Inactive)</option>
//     </select>
//   </div>
// </div>
//   <div className="col-md-6">
//     <label className="form-label">Event Key (Technical ID) *</label>
//     <input
//       type="text"
//       className="form-control"
//       value={emailNotification.EventKey}
//       onChange={(e) => handleEmailNotificationChange("EventKey", e.target.value)}
//       placeholder="e.g. MEDISEVAS_APP_CONFIRM"
//       required
//     />
//   </div>
// </div>
//               </div>
//               <div className="col-md-6">
//                 <div className="mb-3">
//                   <label className="form-label">Email Subject *</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={emailNotification.EmailSubject}
//                     onChange={(e) =>
//                       handleEmailNotificationChange(
//                         "EmailSubject",
//                         e.target.value,
//                       )
//                     }
//                     required
//                     disabled={modalLoading}
//                     placeholder="Enter email subject"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-12">
//                 <div className="mb-3">
//                   <label className="form-label">Email Body *</label>
//                   <textarea
//                     className="form-control"
//                     rows="5"
//                     value={emailNotification.EmailBody}
//                     onChange={(e) =>
//                       handleEmailNotificationChange("EmailBody", e.target.value)
//                     }
//                     required
//                     disabled={modalLoading}
//                     placeholder="Enter email body content"
//                   />
//                 </div>
//               </div>
//             </div>
//             {notificationSettingError && (
//               <div className="alert alert-danger my-3">
//                 <i className="fas fa-exclamation-triangle me-2"></i>
//                 **Error saving notification:** {notificationSettingError}
//               </div>
//             )}
//             <div className="d-flex gap-2 justify-content-end border-top pt-3">
//               {editingNotification && editingType === "email" && (
//                 <button
//                   type="button"
//                   className="filter-button"
//                   onClick={handleCancelEdit}
//                   disabled={modalLoading}
//                 >
//                   Cancel Edit
//                 </button>
//               )}
//               <button
//                 type="submit"
//                 className="save-button"
//                 disabled={notificationSettingLoading || modalLoading}
//               >
//                 {notificationSettingLoading || modalLoading ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm me-2"></span>
//                     Saving...
//                   </>
//                 ) : editingNotification && editingType === "email" ? (
//                   "Update Email Notification"
//                 ) : (
//                   "Create Email Notification"
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>

//       {/* Email Notifications Table */}
//       <div className="card">
//         <div className="card-header bg-light">
//           <div className="row align-items-center">
//             <div className="col-md-6">
//               <h5 className="mb-0">
//                 Email Notifications ({emailNotifications.length})
//               </h5>
//             </div>
//             <div className="col-md-6">
//               <div className="input-group">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Filter email notifications..."
//                   value={notificationFilter}
//                   onChange={(e) => setNotificationFilter(e.target.value)}
//                   disabled={modalLoading}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="card-body">
//           {notificationSettingLoading && emailNotifications.length === 0 ? (
//             <p className="text-info text-center">Loading notifications...</p>
//           ) : emailNotifications.length === 0 ? (
//             <p className="text-muted text-center">
//               No email notifications found for your hospital.
//             </p>
//           ) : (
//             <div className="table-responsive">
//               <table className="table table-striped table-hover">
//                 <thead>
//                   <tr>
//                     <th>ID</th>
//                     <th>Event</th>
//                     <th>Email Subject</th>
//                       <th>Status</th> 
//                     <th>Email Body</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
               
// <tbody>
//   {emailNotifications.map((notification) => (
//     <tr key={notification.id}>
//       <td className="fw-bold">{notification.id}</td>
//       <td>{notification.Event}</td>
//      <td>
//         {notification.IsEmailEnabled === 1 || notification.IsEmailEnabled === "1" ? (
//           <span className="badge bg-success">Active</span>
//         ) : (
//           <span className="badge bg-secondary">Email Not Added</span>
//         )}
//       </td>
//       <td>{notification.email?.EmailSubject || "N/A"}</td>
//       <td>
//         <small className="text-muted">
//           {notification.email?.EmailBody?.length > 50
//             ? `${notification.email.EmailBody.substring(0, 50)}...`
//             : notification.email?.EmailBody || "N/A"}
//         </small>
//       </td>
//       <td>
//         <div className="btn-group btn-group-sm">
//           <button
//             type="button"
//             className="i-btn-edit"
//             onClick={() => handleEditNotification(notification)}
//             disabled={modalLoading}
//           ></button>
//           <button
//             type="button"
//             className="i-btn-delete"
//             onClick={() => handleDeleteNotification(notification.id)}
//             disabled={modalLoading}
//           ></button>
//         </div>
//       </td>
//     </tr>
//   ))}
// </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
const renderEmailNotifications = () => (
  <div>
    <div className="card mb-4">
      <div className="card-header bg-light">
        <h5 className="mb-0">
          {editingNotification ? "Edit Email Notification" : "Create New Email Notification"}
        </h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleEmailNotificationSubmit}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Event Name *</label>
              <input
                type="text"
                className="form-control"
                value={emailNotification.Event}
                onChange={(e) => handleEmailNotificationChange("Event", e.target.value)}
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">Event Key (Technical ID) *</label>
              <input
                type="text"
                className="form-control"
                value={emailNotification.EventKey}
                onChange={(e) => handleEmailNotificationChange("EventKey", e.target.value)}
                placeholder="e.g. APP_CONFIRM"
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">Email Status</label>
              <select
                className="form-select"
                value={emailNotification.IsEmailEnabled}
                onChange={(e) => handleEmailNotificationChange("IsEmailEnabled", e.target.value)}
              >
                <option value={1}>Enabled (Active)</option>
                <option value={0}>Disabled (Inactive)</option>
              </select>
            </div>
            <div className="col-md-12 mb-3">
              <label className="form-label">Email Subject *</label>
              <input
                type="text"
                className="form-control"
                value={emailNotification.EmailSubject}
                onChange={(e) => handleEmailNotificationChange("EmailSubject", e.target.value)}
                required
              />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Email Body *</label>
              <textarea
                className="form-control"
                rows="4"
                value={emailNotification.EmailBody}
                onChange={(e) => handleEmailNotificationChange("EmailBody", e.target.value)}
                required
              />
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-end border-top pt-3">
            {editingNotification && (
              <button type="button" className="filter-button" onClick={handleCancelEdit}>Cancel</button>
            )}
            <button type="submit" className="save-button" disabled={modalLoading}>
              {editingNotification ? "Update Email" : "Create Email"}
            </button>
          </div>
        </form>
      </div>
    </div>

    <div className="card">
      <div className="card-header bg-light d-flex justify-content-between align-items-center">
        <h5 className="mb-0">All Notifications (Email View)</h5>
        <input 
          type="text" 
          className="form-control w-25" 
          placeholder="Search..." 
          onChange={(e) => setNotificationFilter(e.target.value)} 
        />
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Event Name</th>
                <th>Event Key</th>
                <th>Status</th>
                <th>Subject</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {emailNotifications.map((n) => (
                <tr key={n.id}>
                  <td>{n.id}</td>
                  <td>{n.Event}</td>
                  <td><code className="text-primary">{n.EventKey}</code></td>
                   <td>
        <span className={`badge ${Number(n.IsEmailEnabled) === 1 ? "bg-success" : "bg-secondary"}`}>
          {Number(n.IsEmailEnabled) === 1 ? "Active" : "Email Not Added"}
        </span>
      </td>
                  <td>{n.email?.EmailSubject || "N/A"}</td>
                  <td>
                    <button className="i-btn-edit" onClick={() => handleEditNotification(n)}></button>
                    <button className="i-btn-delete"  onClick={() => handleChannelSpecificDelete(n, "email")} disabled={modalLoading}></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

  // Render SMS Notifications
//   const renderSmsNotifications = () => (
//     <div>
//       {/* Create/Edit SMS Notification Form */}
//       <div className="card mb-4">
//         <div className="card-header bg-light">
//           <h5 className="mb-0">
//             {editingNotification && editingType === "sms"
//               ? "Edit SMS Notification"
//               : "Create New SMS Notification"}
//           </h5>
//         </div>
//         <div className="card-body">
//           <form onSubmit={handleSmsNotificationSubmit}>
//             <div className="row">
//               <div className="col-md-6">
//                 <div className="mb-3">
//                   <label className="form-label">Event *</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={smsNotification.Event}
//                     onChange={(e) =>
//                       handleSmsNotificationChange("Event", e.target.value)
//                     }
//                     required
//                     disabled={modalLoading}
//                     placeholder="Enter event name"
//                   />
//                 </div>
//                 <div className="col-md-6">
//   <div className="mb-3">
//     <label className="form-label fw-bold">SMS Status</label>
//     <select
//       className="form-select"
//       value={smsNotification.IsSmsEnabled}
//       onChange={(e) => handleSmsNotificationChange("IsSmsEnabled", e.target.value)}
//     >
//       <option value={1}>Enabled (Active)</option>
//       <option value={0}>Disabled (Inactive)</option>
//     </select>
//   </div>
// </div>
//                 <div className="mb-3">
//                   <label className="form-label">Sample Message *</label>
//                   <textarea
//                     className="form-control"
//                     rows="6"
//                     value={smsNotification.SampleMessage}
//                     onChange={(e) =>
//                       handleSmsNotificationChange(
//                         "SampleMessage",
//                         e.target.value,
//                       )
//                     }
//                     required
//                     disabled={modalLoading}
//                     placeholder="Enter SMS message template"
//                   />
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <div className="mb-3">
//                   <label className="form-label">SMS Type</label>
//                   <select
//                     className="form-select"
//                     value={smsNotification.sms_type}
//                     onChange={(e) =>
//                       handleSmsNotificationChange("sms_type", e.target.value)
//                     }
//                     disabled={modalLoading}
//                   >
//                     <option value="transactional">Transactional</option>
//                     <option value="promotional">Promotional</option>
//                     <option value="otp">OTP</option>
//                   </select>
//                 </div>
//                 <div className="mb-3">
//                   <label className="form-label">DLT Entity ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={smsNotification.dlt_entity_id}
//                     onChange={(e) =>
//                       handleSmsNotificationChange(
//                         "dlt_entity_id",
//                         e.target.value,
//                       )
//                     }
//                     disabled={modalLoading}
//                     placeholder="Enter DLT Entity ID"
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="form-label">DLT Template ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={smsNotification.dlt_template_id}
//                     onChange={(e) =>
//                       handleSmsNotificationChange(
//                         "dlt_template_id",
//                         e.target.value,
//                       )
//                     }
//                     disabled={modalLoading}
//                     placeholder="Enter DLT Template ID"
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="form-label">Sender ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={smsNotification.sender_id}
//                     onChange={(e) =>
//                       handleSmsNotificationChange("sender_id", e.target.value)
//                     }
//                     disabled={modalLoading}
//                     placeholder="Enter Sender ID"
//                   />
//                 </div>
//               </div>
//             </div>
//             {notificationSettingError && (
//               <div className="alert alert-danger my-3">
//                 <i className="fas fa-exclamation-triangle me-2"></i>
//                 **Error saving notification:** {notificationSettingError}
//               </div>
//             )}
//             <div className="d-flex gap-2 justify-content-end border-top pt-3">
//               {editingNotification && editingType === "sms" && (
//                 <button
//                   type="button"
//                   className="filter-button"
//                   onClick={handleCancelEdit}
//                   disabled={modalLoading}
//                 >
//                   Cancel Edit
//                 </button>
//               )}
//               <button
//                 type="submit"
//                 className="save-button"
//                 disabled={notificationSettingLoading || modalLoading}
//               >
//                 {notificationSettingLoading || modalLoading ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm me-2"></span>
//                     Saving...
//                   </>
//                 ) : editingNotification && editingType === "sms" ? (
//                   "Update SMS Notification"
//                 ) : (
//                   "Create SMS Notification"
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>

//       {/* SMS Notifications Table */}
//       <div className="card">
//         <div className="card-header bg-light">
//           <div className="row align-items-center">
//             <div className="col-md-6">
//               <h5 className="mb-0">
//                 SMS Notifications ({smsNotifications.length})
//               </h5>
//             </div>
//             <div className="col-md-6">
//               <div className="input-group">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Filter SMS notifications..."
//                   value={notificationFilter}
//                   onChange={(e) => setNotificationFilter(e.target.value)}
//                   disabled={modalLoading}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="card-body">
//           {notificationSettingLoading && smsNotifications.length === 0 ? (
//             <p className="text-info text-center">Loading notifications...</p>
//           ) : smsNotifications.length === 0 ? (
//             <p className="text-muted text-center">
//               No SMS notifications found for your hospital.
//             </p>
//           ) : (
//             <div className="table-responsive">
//               <table className="table table-striped table-hover">
//                 <thead>
//                   <tr>
//                     <th>ID</th>
//                     <th>Event</th>
//                     <th>SMS Type</th>
//                     <th>Sample Message</th>
//                     <th>Sender ID</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//   {smsNotifications.map((notification) => (
//     <tr key={notification.id}>
//       <td className="fw-bold">{notification.id}</td>
//       <td>{notification.Event}</td>
//       <td>
//         <span className={`badge ${notification.sms?.sms_type === "transactional" ? "bg-info" : "bg-warning"}`}>
//           {notification.sms?.sms_type || "N/A"}
//         </span>
//       </td>
//       <td>
//         <small className="text-muted">
//           {/* यहाँ बदलाव: notification.sms?. का उपयोग किया है */}
//           {notification.sms?.SampleMessage?.length > 50
//             ? `${notification.sms.SampleMessage.substring(0, 50)}...`
//             : notification.sms?.SampleMessage || "N/A"}
//         </small>
//       </td>
//       <td>{notification.sms?.sender_id || "N/A"}</td>
//       <td>
//         <div className="btn-group btn-group-sm">
//           <button
//             type="button"
//             className="i-btn-edit"
//             onClick={() => handleEditNotification(notification)}
//             disabled={modalLoading}
//           ></button>
//           <button
//             type="button"
//             className="i-btn-delete"
//             onClick={() => handleDeleteNotification(notification.id)}
//             disabled={modalLoading}
//           ></button>
//         </div>
//       </td>
//     </tr>
//   ))}
// </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
const renderSmsNotifications = () => (
  <div>
    <div className="card mb-4">
      <div className="card-header bg-light">
        <h5 className="mb-0">
          {editingNotification ? "Edit SMS Notification" : "Create New SMS Notification"}
        </h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSmsNotificationSubmit}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Event Name *</label>
              <input
                type="text"
                className="form-control"
                value={smsNotification.Event}
                onChange={(e) => handleSmsNotificationChange("Event", e.target.value)}
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">Event Key (Technical ID) *</label>
              <input
                type="text"
                className="form-control"
                value={smsNotification.EventKey}
                onChange={(e) => handleSmsNotificationChange("EventKey", e.target.value)}
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label ">SMS Status</label>
              <select
                className="form-select"
                value={smsNotification.IsSmsEnabled}
                onChange={(e) => handleSmsNotificationChange("IsSmsEnabled", e.target.value)}
              >
                <option value={1}>Enabled (Active)</option>
                <option value={0}>Disabled (Inactive)</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">SMS Type</label>
              <select
                className="form-select"
                value={smsNotification.sms_type}
                onChange={(e) => handleSmsNotificationChange("sms_type", e.target.value)}
              >
                <option value="transactional">Transactional</option>
                <option value="promotional">Promotional</option>
                <option value="otp">OTP</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Sender ID</label>
              <input
                type="text"
                className="form-control"
                value={smsNotification.sender_id}
                onChange={(e) => handleSmsNotificationChange("sender_id", e.target.value)}
              />
            </div>
            <div className="col-md-12 mb-3">
              <label className="form-label">Sample Message *</label>
              <textarea
                className="form-control"
                rows="3"
                value={smsNotification.SampleMessage}
                onChange={(e) => handleSmsNotificationChange("SampleMessage", e.target.value)}
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">DLT Entity ID</label>
              <input
                type="text"
                className="form-control"
                value={smsNotification.dlt_entity_id}
                onChange={(e) => handleSmsNotificationChange("dlt_entity_id", e.target.value)}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">DLT Template ID</label>
              <input
                type="text"
                className="form-control"
                value={smsNotification.dlt_template_id}
                onChange={(e) => handleSmsNotificationChange("dlt_template_id", e.target.value)}
              />
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-end border-top pt-3">
            {editingNotification && (
              <button type="button" className="filter-button" onClick={handleCancelEdit}>Cancel</button>
            )}
            <button type="submit" className="save-button" disabled={modalLoading}>
              {editingNotification ? "Update SMS" : "Create SMS"}
            </button>
          </div>
        </form>
      </div>
    </div>

    <div className="card">
      <div className="card-header bg-light d-flex justify-content-between align-items-center">
        <h5 className="mb-0">All Notifications (SMS View)</h5>
        <input 
          type="text" 
          className="form-control w-25" 
          placeholder="Search..." 
          onChange={(e) => setNotificationFilter(e.target.value)} 
        />
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Event</th>
                <th>Event Key</th>
                <th>Status</th>
                <th>Sample Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {smsNotifications.map((n) => (
                <tr key={n.id}>
                  <td>{n.id}</td>
                  <td>{n.Event}</td>
                  <td><code className="text-primary">{n.EventKey}</code></td>
                 
<td>
  <span className={`badge ${Number(n.IsSmsEnabled) === 1 ? "bg-success" : "bg-secondary"}`}>
    {Number(n.IsSmsEnabled) === 1 ? "Active" : "SMS Not Added"}
  </span>
</td>
                  <td><small>{n.sms?.SampleMessage || "N/A"}</small></td>
                  <td>
                    <button className="i-btn-edit" onClick={() => handleEditNotification(n)}></button>
                    <button className="i-btn-delete" onClick={() => handleChannelSpecificDelete(n, "sms")} disabled={modalLoading}></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

  // Render Notification Settings Tab
  const renderNotificationSettingsTab = () => (
    <div id="notification-form-top" className="tab-pane fade show active">
      <h3 className="mb-4 text-primary">Notification Settings</h3>
      <ul className="nav nav-pills mb-4">
        <li className="nav-item">
          <button
            className={`nav-link bg-info rounded-pill ${notificationTypeTab === "email" ? "active view-button" : "view-button"}`}
            onClick={() => setNotificationTypeTab("email")}
            disabled={modalLoading}
          >
            Email Notifications
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link bg-info rounded-pill ${notificationTypeTab === "sms" ? "active view-button" : "view-button"}`}
            onClick={() => setNotificationTypeTab("sms")}
            disabled={modalLoading}
          >
            SMS Notifications
          </button>
        </li>
      </ul>

      {notificationTypeTab === "email" && renderEmailNotifications()}
      {notificationTypeTab === "sms" && renderSmsNotifications()}
    </div>
  );

  return (
    <div className="page-wrapper ml-0">
      <div className="content-container">
        <div className="page-header filter-bar rounded">
          <div className="row align-items-center">
            <div className="col">
              <h4 className="page-title">Notification Settings</h4>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/doctor/dashboard">Admin Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  Manage your notification, SMS, and email configurations
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="card">
        <div className="card-body pt-3">
          {/* Debug Info - Remove in production */}
          <div className="alert alert-info d-none">
            <strong>Debug Info:</strong>
            <br />
            Total Notifications: {notificationSettings?.length}
            <br />
            Hospital Notifications: {hospitalNotificationSettings?.length}
            <br />
            Email Notifications: {emailNotifications?.length}
            <br />
            SMS Notifications: {smsNotifications?.length}
          </div>

          {/* Main Tabs Navigation */}
          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "notification" ? "active" : ""}`}
                onClick={() => setActiveTab("notification")}
                disabled={modalLoading}
              >
                <i className="fas fa-bell me-2"></i>Notification Settings
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "sms" ? "active" : ""}`}
                onClick={() => setActiveTab("sms")}
                disabled={modalLoading}
              >
                <i className="fas fa-sms me-2"></i>SMS Settings
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "email" ? "active" : ""}`}
                onClick={() => setActiveTab("email")}
                disabled={modalLoading}
              >
                <i className="fas fa-envelope me-2"></i>Email Settings
              </button>
            </li>
          </ul>

          <div className="tab-content p-4">
            {activeTab === "email" && renderEmailSettingsTab()}
            {activeTab === "sms" && renderSmsSettingsTab()}
            {activeTab === "notification" && renderNotificationSettingsTab()}
          </div>
        </div>
        </div>
      </div>

      {/* Message Modal */}
      <MessageModal
        show={modalShow}
        onClose={handleModalClose}
        onConfirm={handleModalConfirm}
        title={modalTitle}
        message={modalMessage}
        variant={modalVariant}
        showConfirm={modalConfirmAction !== null}
        confirmText="Yes, Continue"
        cancelText="Cancel"
        loading={modalLoading}
      />
    </div>
  );
};

export default NotificationSettings;
